import React from 'react';
import { AnimatedSection } from '../shared/AnimatedSection';
import { Sign } from '../../data/signs';
interface SignSolucionProps {
  sign: Sign;
}
export function SignSolucion({
  sign
}: SignSolucionProps) {
  const {
    nucleoTitle,
    nucleoDescription
  } = sign.content;
  return <section className="py-20 md:py-28 px-4 md:px-6 bg-transparent" data-id="element-1090">
      <div className="container mx-auto max-w-4xl" data-id="element-1091">
        <AnimatedSection data-id="element-1092">
          <h2 className="text-4xl md:text-5xl font-serif font-bold text-center mb-8 md:mb-10 px-2" style={{
          color: sign.colors.accent,
          textShadow: `0 0 40px ${sign.colors.primary}60`
        }} data-id="element-1093">
            {nucleoTitle}
          </h2>
        </AnimatedSection>

        <AnimatedSection delay={0.3} data-id="element-1094">
          <p className="text-gray-100 text-lg md:text-xl leading-relaxed text-center max-w-3xl mx-auto font-serif px-2" data-id="element-1095">
            {nucleoDescription}
          </p>
        </AnimatedSection>
      </div>
    </section>;
}